module.exports = __webpack_public_path__ + "static/sofia-0a9053d0a4d63ca01e5f8a4b9c401620.jpg";